import {AfterViewInit, ChangeDetectionStrategy, Component, effect, ElementRef, Injector, input, viewChild} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Gruppedata, Konfigurasjon, ÅrshjulGraf} from "../årshjul-graf/ÅrshjulGraf";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import { Klokke } from "felles-ng2/tjenester/Klokke";

const debug = initDebugger('ÅrshjulGrafUtenMøterKomponent');

@Component({
    selector: 'aarshjul-graf-uten-moeter',
    templateUrl: 'årshjul-graf-uten-møter.html',
    styleUrl: 'årshjul-graf-uten-møter.scss',
    host: {'data-testid': 'årshjul-graf-uten-møter'},
    imports: [
        MatButtonModule,
        TranslateModule,

    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ÅrshjulGrafUtenMøterKomponent implements AfterViewInit {

    kontainerElement = viewChild.required<ElementRef<HTMLElement>>('kontainer');

    data = input<Gruppedata[]>([]);

    private årshjulGraf!: ÅrshjulGraf; //settes i ngAfterViewInit

    constructor(private oversettelser: Oversettelser, private klokke:Klokke,  private injector: Injector) {
    }

    ngAfterViewInit(): void {
        //kontainerElement er ikke tilgjengelig når konstruktør kalles, gjøres derfor i ngAfterViewInit
        this.tegnUtGraf();
        //lytter så til endringer i this.data hvorpå grad oppdateres
        effect(() => this.årshjulGraf.tegnGruppedata(this.data()), {injector: this.injector});

        effect(() => {
            console.log('# DATA', this.data());
        }, {injector: this.injector});

    }


    // private hjelpemetoder

    private tegnUtGraf() {
        const konfigurasjon = {markertUke: ÅrshjulGraf.ukenummer(this.klokke.nåSomZonedDateTime())} as Konfigurasjon;

        this.årshjulGraf = new ÅrshjulGraf(
          this.kontainerElement().nativeElement,
          konfigurasjon,
          this.oversettelser
        );
    }
}
